module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-d60b72797083ebec86e53c1ab5568190.webp";